import type { Location } from 'react-router-dom';
import { OrderStatus } from 'src/types';
import { EditOrderGuardInput, EditOrderGuardResult } from 'src/types/loaders';
import { isCustomerSuccessOrSalesUser } from 'src/utils';

type LdtOrderEditFields = {
  id: string;
  status: OrderStatus;
};

export function getRowLink(
  order: LdtOrderEditFields,
  organization: string,
  location: Location,
  _userId: string,
): {
  pathname: string;
  state: { background: { pathname: string; search: string } };
} {
  return {
    pathname: `/${organization}/orders/${order.id}`,
    state: {
      background: { pathname: location.pathname, search: location.search },
    },
  };
}

export function canEditOrder(
  order: LdtOrderEditFields,
  _userInfoId: string,
): boolean {
  return (
    isCustomerSuccessOrSalesUser() &&
    order.status === OrderStatus.QualityControlPending
  );
}

/**
 * Ancillary Lab workflow: only CS/Sales can access order edit; order must be QC Pending.
 */
export function getEditOrderRedirect(
  input: EditOrderGuardInput,
): EditOrderGuardResult {
  const { redirectBasePath, orderId } = input;
  const redirectPath = `${redirectBasePath}/orders/${orderId}`;

  if (!canEditOrder(input.order, input.userId)) {
    if (!isCustomerSuccessOrSalesUser()) {
      return {
        redirectPath,
        errorMessage: 'You are not authorized to edit this order.',
      };
    } else if (input.order.status !== OrderStatus.QualityControlPending) {
      return {
        redirectPath,
        errorMessage: 'This order cannot be edited at this time.',
      };
    }
  }

  return null;
}
